
import {
  useEffect,
  useState,
} from "react";

type RemoteAssets =
  Record<string, string>;

export default function useRemoteAssets(
  token?: string
) {

  const [assets, setAssets] =
    useState<RemoteAssets | null>(
      null
    );

  useEffect(() => {

    let mounted = true;

    const load = async () => {

      try {

        const mod =
          await import(
            "remote_app/assets"
          );

        type AssetsModule = {
          getAssets?: (
            token?: string
          ) => RemoteAssets;

          default?: {
            getAssets?: (
              token?: string
            ) => RemoteAssets;
          };
        };

        const typedMod =
          mod as AssetsModule;

        const getAssetsFn =
          typedMod.getAssets ||
          typedMod.default
            ?.getAssets;

        if (
          typeof getAssetsFn ===
          "function"
        ) {

          const loadedAssets =
            getAssetsFn(token);

          if (mounted) {

            setAssets(
              loadedAssets
            );

          }

          return;
        }

        if (
          mod &&
          typeof mod === "object"
        ) {

          if (mounted) {

            setAssets(
              mod as RemoteAssets
            );

          }

          return;
        }

        if (mounted) {

          setAssets(null);

        }

      } catch (err) {

        console.error(
          "Failed to load remote assets:",
          err
        );

        if (mounted) {

          setAssets(null);

        }
      }
    };

    load();

    return () => {

      mounted = false;

    };

  }, [token]);

  return assets;
}